import { apiFetch } from "../lib/api";

export interface NotificationSettings {
  configured: boolean;
  enabled: boolean;
  channel: string;
  chat_id: string | null;
  has_token: boolean;
}

export interface TelegramSettingsUpdate {
  bot_token: string;
  chat_id: string;
  enabled: boolean;
}

export interface NotificationTestResult {
  ok: boolean;
  detail: string;
}

export async function getNotificationSettings(): Promise<NotificationSettings> {
  return apiFetch<NotificationSettings>("/settings/notifications");
}

export async function putNotificationSettings(
  payload: TelegramSettingsUpdate,
): Promise<NotificationSettings> {
  return apiFetch<NotificationSettings>("/settings/notifications", {
    method: "PUT",
    body: payload,
  });
}

export async function deleteNotificationSettings(): Promise<void> {
  await apiFetch<void>("/settings/notifications", { method: "DELETE" });
}

export async function testNotificationSettings(): Promise<NotificationTestResult> {
  return apiFetch<NotificationTestResult>("/settings/notifications/test", {
    method: "POST",
  });
}
